export const PAGE_TITLE = 'Cross Reference Part Search';
export const PAGE_CONTENT_GROUP = 'Resources';
export const PAGE_CONTENT_SUB_GROUP = 'Cross Reference Part Search';
export const PAGE_TYPE = 'PS';
export const PAGE_SUB_TYPE = 'PCR';
export const PAGE_ID = 'LP';
export const PAGE_STATE = '';
export const DIR_SUB_AVAILABLE = 'Direct Subs Available';
export const DRIECT = 'Direct';
export const ACTIVE = 'Active';
export const MFR_RECOMMENDED = 'MfrRecommended';
export const SOURCE_PART = 'Source Part';
export const SEARCH_FOR_PART = 'ref_page_event=Search for Part';
export const NON_DIGIKEY = 'Non Digikey';
export const UTAG_DATA = {
  utagData: {
    page_title: PAGE_TITLE,
    page_content_group: PAGE_CONTENT_GROUP,
    page_content_sub_group: PAGE_CONTENT_SUB_GROUP,
    page_type: PAGE_TYPE,
    page_sub_type: PAGE_SUB_TYPE,
    page_id: PAGE_ID
  }
};
export const MATCHTYPE_SORT = [
  'Direct',
  'ParametricEquivalent',
  'MfrRecommended',
  'Upgrade',
  'Similar'
];
export const HOST_NAME_LOCAL = 'https://localhost:44335';
export const IS_INVERTED_PIN = '(NOT)';
export const USER_DATA_LOGGED_IN = {
  IsLoggedIn: true,
  DisplayName: 'TEST FIRST NAME TEST LAST NAME',
  CompanyName: 'TAXI PRESTO JOB BOHUSLAV',
  CustomerId: 12392102,
  Email: 'testsingle@digikey.com',
  Name: 'TEST FIRST NAME TEST LAST NAME',
  wasFetched: true
};
